import { messaging, getToken } from "../../firebase";
import { getEnv } from "helpers/Env";

export const getFBaseToken = async () => {
  let token;

  try {
    token = await getToken(messaging, {
      vapidKey:
        "BKPpSa8yA3-HfXbZmY3PbKzBzowoHF1XZHJengeFtgWSkrbG9JZF5TMOezqrI29BDBOzFm8cs_OZ3COoBP-YfaQ",
    });
  } catch (error) {
    
  }

  return token;
};
